import * as Numbers from "ixfx/numbers";
import { Easings } from "ixfx/modulation";
import { randomElement } from "ixfx/arrays";
import chroma from 'chroma-js';

import { CreatedRing, GeoLocation, State, WindDataPoint } from "./types";
import * as Parse from './parse';
import * as SvgDraw from './svg-draw';
import { Svg } from 'ixfx/visual';
import * as Location from './location';
import * as Notify from './notify';
import { places } from './places';
import * as Colours from './colours';

import { Variables } from "ixfx/dom";
import { Debug, Flow, Modulation } from "ixfx/bundle";
import { Arrays } from "ixfx/data";

const settings = Object.freeze({
  btnVisit: document.querySelector<HTMLButtonElement>(`#btnVisit`)!,
  anim: Flow.continuously(draw, 0),
  timingFactory: Modulation.timingSourceFactory(`elapsed`, 10_000, { cycleLimit: 1 }),
  svgParent: document.querySelector<SVGSVGElement>(`#canvas`)!
});

let state: State = {
  rings: [],
  visualRings: [],
  colours: [ `black`, `white` ],
  location: randomElement(places),
  speedScale: (v) => v,
  gustScale: (v: number) => v
};

function draw() {
  const { svgParent } = settings;

  let { timeline } = state;
  if (!timeline) {
    timeline = settings.timingFactory();
    saveState({ timeline });
  }

  const t = timeline();
  let somethingRunning = false;
  svgParent.style.scale = (11 - Numbers.scaleClamped(t, 0, 1, 1, 10, Easings.Named.quadInOut)).toString();
  for (const ring of state.visualRings) {
    //animRing(ring, t);
    ring.group.tick();
    if (!ring.group.isDone) somethingRunning = true;
  }

  if (!somethingRunning) {
    return false; // Stop loop
  }
  //return true;
}


function cycleColours() {
  const colours = Arrays.shuffle(Colours.getBidi());
  saveState({ colours });
  Variables.setVariables({
    'colour-a': colours[ 0 ],
    'colour-b': colours[ 1 ]
  }, document.documentElement);
}

async function fetch() {
  let data: WindDataPoint[] = [];
  try {
    data = await Parse.getData(state.location);
    Notify.show(state.location.title, true);
  } catch (error) {
    Notify.show(Debug.getErrorMessage(error) + '. Using demo data.');
    data = Parse.getFallbackData();
  }

  const speedScale = Numbers.scaler(0, Numbers.max(data.map(d => d.speed)));
  const gustScale = Numbers.scaler(0, Numbers.max(data.map(d => d.gusts)));

  const rings = Parse.segmentByPeriod({ hours: 24 }, data);
  const visualRings = SvgDraw.createRings({
    strokeStyle: chroma(state.colours[ 1 ]).alpha(0.7).hex(),
    barMaximum: 100,
    minimumThickness: 2,
    gustThicknessScale: 15,
    ringDurationMs: 1000 * 60 * 60 * 24,
    speedScale,
    gustScale,
    origin: { x: 500, y: 500 },
    svg: Svg.makeHelper(document.querySelector(`#canvas`)!)
  }, rings);

  saveState({ rings, visualRings, speedScale, gustScale });

  for (const ring of state.visualRings) {
    ring.group.reset();
  }
  settings.anim.reset();
}

async function useState() {

}

async function setLocation(geo: GeoLocation) {
  saveState({ location: geo, rings: [] });
  await fetch();
  useState();
}

async function setup() {
  const { btnVisit } = settings;
  const splashEl = document.querySelector(`#splash`)!;

  cycleColours();

  Notify.init();
  Location.init();
  Location.events.addEventListener(`located`, (args) => {
    const geo = (args as CustomEvent).detail as GeolocationCoordinates;
    setLocation(
      {
        latitude: geo.latitude,
        longitude: geo.longitude,
        title: `Your location`
      });
    useState();
  });
  Location.events.addEventListener(`not-located`, () => {
    fetch();
    useState(); // Use fallback data
  });

  btnVisit.addEventListener(`click`, () => {
    cycleColours();
    setLocation(randomElement(places));
    Location.showLocationButton();
    splashEl.classList.add(`hidden`);
  });

  splashEl.addEventListener(`click`, () => {
    splashEl?.classList.add(`hidden`);
  });
}

setup();

/**
 * Save state
 */
function saveState(s: Partial<State>) {
  state = Object.freeze({
    ...state,
    ...s,
  });
}

// import {animateNumber} from './anim/polar';
// animateNumber(100,0, Modulation.timeModulator())